<div class="match-label d-flex" (click)="handleClick()">
    <app-svg-icon [icon]="icon" size="medium" />
    <span class="match-label-text">
        {{ text }}
    </span>
</div>

@if (isMenuVisible) {
    <app-match-submenu class="match-submenu" />
}
